let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kLUzc")).then(() => parcelRequire('8DS6n'));